export default (theme) => ({
  sendIcon: {
    fill: theme.palette.background.white,
    width: 30,
    height: 'auto',
  },
});
